export interface ParsedCsv {
  headers: string[]
  rows: string[][]
}

// Minimal RFC-4180 style parser: handles quoted fields, escaped quotes and CRLF
export function parseCsv(text: string): ParsedCsv {
  const parsed: string[][] = []
  let row: string[] = []
  let value = ''
  let inQuotes = false

  for (let i = 0; i < text.length; i++) {
    const char = text[i]

    if (inQuotes) {
      if (char === '"') {
        if (text[i + 1] === '"') {
          value += '"'
          i++
        } else {
          inQuotes = false
        }
      } else {
        value += char
      }
      continue
    }

    if (char === '"') {
      inQuotes = true
    } else if (char === ',') {
      row.push(value)
      value = ''
    } else if (char === '\n') {
      row.push(value)
      parsed.push(row)
      row = []
      value = ''
    } else if (char !== '\r') {
      value += char
    }
  }

  if (value !== '' || row.length > 0) {
    row.push(value)
    parsed.push(row)
  }

  const nonEmpty = parsed.filter((cells) =>
    cells.some((cell) => cell.trim() !== ''),
  )
  const [headers = [], ...body] = nonEmpty

  return {
    headers: headers.map((header) => header.trim()),
    rows: body,
  }
}
